import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import OpenOrdersBody from '../shared/OpenOrdersBody';
import { ShippedOrdersOverlay } from './ShippedOrdersOverlay';
import { closeShopUtilityPage } from '../../utils/lastShopReturnContext';

const MyOrdersPage: React.FC = () => {
    const history = useHistory();
    const [tabIndex, setTabIndex] = useState(0);

    useEffect(() => {
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key !== 'Escape') {
                return;
            }

            event.preventDefault();
            closeShopUtilityPage(history);
        };

        document.addEventListener('keydown', onKeyDown);

        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [history]);

    return (
        <div className="order-history-page my-orders-page">
            <div className="order-history-page__header my-orders-page__header">
                <div>
                    <h1 className="order-history-page__title">My orders</h1>
                    <p className="order-history-page__subtitle">
                        View open and completed orders, shipments and tracking.
                    </p>
                </div>
                <button
                    type="button"
                    className="my-orders-page__history-link"
                    onClick={() => history.push('/activity-history')}
                >
                    Activity history
                </button>
            </div>

            <div className="my-orders-page__content">
                <Tabs selectedIndex={tabIndex} onSelect={setTabIndex}>
                    <TabList>
                        <Tab>Not Completed</Tab>
                        <Tab>Completed</Tab>
                    </TabList>
                    <TabPanel>
                        <OpenOrdersBody applyChanges={() => {}} show={tabIndex === 0} />
                    </TabPanel>
                    <TabPanel>
                        <ShippedOrdersOverlay show={tabIndex === 1} />
                    </TabPanel>
                </Tabs>
            </div>
        </div>
    );
};

export default MyOrdersPage;
